export const Images = {
  StartRightArrow: require("../assets/images/start-right-arrrow.png"),
  RightArrow: require("../assets/images/right-arrow.png"),
  LeftArrow: require("../assets/images/left-arrow.png"),
  Carret: require("../assets/images/carret.png"),
};
